<template>
  <div>
    <div class="d-flex align-center mb-2">
      <div class="text-h6 font-weight-bold">Cart</div>
      <v-spacer />
      <v-btn text small :disabled="lines.length === 0" @click="$emit('clear')">Clear</v-btn>
    </div>

    <v-alert v-if="lines.length === 0" type="info" outlined>
      Cart is empty.
    </v-alert>

    <v-card v-else rounded="xl" outlined>
      <v-list two-line>
        <v-list-item v-for="line in lines" :key="line.id">
          <v-list-item-avatar size="56" rounded="lg">
            <v-img :src="line.imageUrl || fallbackImg" contain />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title class="line-clamp-2">{{ line.name }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ money(line.price) }} · Qty {{ line.qty }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action class="d-flex flex-row align-center">
            <v-btn icon @click="$emit('dec', line.id)"><v-icon>mdi-minus</v-icon></v-btn>
            <div style="min-width: 26px; text-align: center;">{{ line.qty }}</div>
            <v-btn icon @click="$emit('inc', line.id)"><v-icon>mdi-plus</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>

      <v-divider />

      <v-card-text class="d-flex align-center">
        <div class="font-weight-bold text-subtitle-1">Total: {{ money(total) }}</div>
        <v-spacer />
        <v-btn color="primary" large>Checkout</v-btn>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "RemoteStoreCart",
  props: {
    products: { type: Array, default: () => [] },
    cart: { type: Object, default: () => ({}) },
  },
  data() {
    return { fallbackImg: "https://via.placeholder.com/300x200?text=No+Image" };
  },
  computed: {
    lines() {
      const map = new Map((this.products || []).map((p) => [String(p.id), p]));
      return Object.keys(this.cart)
        .map((id) => {
          const p = map.get(String(id));
          if (!p) return null;
          return { ...p, qty: Number(this.cart[id] || 0) };
        })
        .filter(Boolean);
    },
    total() {
      return this.lines.reduce((sum, l) => sum + Number(l.price || 0) * Number(l.qty || 0), 0);
    },
  },
  methods: {
    money(v) {
      const n = Number(v || 0);
      return n.toLocaleString(undefined, { style: "currency", currency: "USD" });
    },
  },
};
</script>

<style scoped>
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>